import { useEffect } from "react";
import { Reveal } from "@/components/common/Reveal";

const isPrerender = () =>
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

const loadEmbedSocialScript = () => {
  // Never inject during react-snap prerender — otherwise a half-loaded widget
  // and the loader script get baked into the static HTML, which blocks the
  // widget from re-initialising on the live page (testimonials show empty).
  if (isPrerender()) return;
  if (document.getElementById("EmbedSocialHashtagScript")) return;
  const script = document.createElement("script");
  script.id = "EmbedSocialHashtagScript";
  script.src = "https://embedsocial.com/cdn/ht.js";
  document.head.appendChild(script);
};

export const GoogleReviewsWidget = ({ muted = false }) => {
  useEffect(() => {
    if (isPrerender()) return;
    loadEmbedSocialScript();
  }, []);

  return (
    <section
      data-testid="google-reviews-section"
      className={muted ? "bg-brand-soft" : "bg-white"}
    >
      <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-28 lg:px-20">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue">
            Live From Google
          </span>
          <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-brand-dark md:text-5xl">
            What patients are saying <span className="italic text-brand-blue">right now</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-10">
          <div
            className="embedsocial-hashtag"
            data-ref="2cfcaee016446f33d1bccd8b30af0537a6fc62a8"
            data-testid="google-reviews-widget"
          >
            <a
              className="feed-powered-by-es feed-powered-by-es-feed-img es-widget-branding"
              href="https://embedsocial.com/google-reviews-widget/"
              target="_blank"
              rel="noopener noreferrer"
              title="Embed Google reviews"
            >
              <img src="https://embedsocial.com/cdn/icon/embedsocial-logo.webp" alt="EmbedSocial" />
              <div className="es-widget-branding-text">Embed Google reviews</div>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
